import { render, staticRenderFns } from "./Gram.vue?vue&type=template&id=3058263a"
import script from "./Gram.vue?vue&type=script&lang=js"
export * from "./Gram.vue?vue&type=script&lang=js"
import style0 from "./Gram.vue?vue&type=style&index=0&id=3058263a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports